'use client';

import { useEffect } from 'react';

import { cn } from '../../libs/utils';
import { TextButton } from '../button';

import { Toast, ToastProvider, ToastTitle, ToastViewport } from './toast';
import { useToast } from './useToast';
import { getToastIcon } from './util/getToastIcon';

export function Toaster() {
  const { toasts, dismiss } = useToast();

  const oldestFirst = [...toasts].reverse();
  const stackOrder = new Map(
    [...oldestFirst.filter((t) => t.autoClose !== false), ...oldestFirst.filter((t) => t.autoClose === false)].map((t, index) => [t.id, index])
  );

  // Radix pause 고착 방지: 화면 복귀 시 focus 이벤트를 강제로 쏴 resume 시킨다.
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        window.dispatchEvent(new Event('focus'));
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);

  return (
    <ToastProvider>
      {toasts.map(({ id, title, button, icon, duration = 3000, autoClose = true, open, variant, onClick, ...props }) => (
        <Toast
          key={id}
          {...props}
          style={{ ...props.style, order: stackOrder.get(id) }}
          duration={autoClose ? duration : 10 ** 10}
          open={open}
          onPause={() => {
            if (!autoClose || button) return;
            setTimeout(() => {
              dismiss(id);
            }, 1000);
          }}
        >
          <div className={cn('flex items-center gap-tiny-large py-normal-medium')}>
            {getToastIcon(variant)}
            {title && <ToastTitle>{title}</ToastTitle>}
          </div>
          {button && (
            <TextButton variant={'inverse'} size={'xsmall'} className={'label-xsmall-medium text-neutral-foreground-inverse-main'} onClick={onClick}>
              {button}
            </TextButton>
          )}
        </Toast>
      ))}
      <ToastViewport />
    </ToastProvider>
  );
}
